/**
 * OVER 9000 APP REGISTRY
 * ======================
 * Append one object when you ship. Pair it with a screenshot in /public/shots.
 * Full workflow: docs/SHIP.md
 *
 * slug        subdomain label → https://{slug}.over9000.cc  (unless `url` overrides)
 * title       short name on hover / inventory
 * url         canonical URL (usually https://{slug}.over9000.cc)
 * screenshot  path under /public, e.g. /shots/foo.png
 * shippedAt   ISO date (YYYY-MM-DD or full ISO 8601)
 * status      "live" only when that hostname actually serves the app
 * example     true = seed / mock row — labeled in the UI, excluded from the 9000 count
 * blurb       one-line description (optional)
 */

export type AppStatus = "live" | "wip";

export type AppEntry = {
  slug: string;
  title: string;
  url: string;
  screenshot: string;
  shippedAt: string;
  status: AppStatus;
  example?: boolean;
  blurb?: string;
};

/**
 * Seed rows so the mosaic renders in preview. They are NOT live apps.
 * Replace or delete these the moment real ships exist.
 */
export const APPS: AppEntry[] = [
  {
    slug: "hello",
    title: "HELLO",
    url: "https://hello.over9000.cc",
    screenshot: "/shots/hello.svg",
    shippedAt: "2026-09-17",
    status: "wip",
    example: true,
    blurb: "Seed frame — a terminal saying hello. Not deployed.",
  },
  {
    slug: "lab",
    title: "THE LAB",
    url: "https://lab.over9000.cc",
    screenshot: "/shots/lab.svg",
    shippedAt: "2026-09-18",
    status: "wip",
    example: true,
    blurb: "Seed frame — scratch space for experiments. Not deployed.",
  },
  {
    slug: "atlas",
    title: "ATLAS",
    url: "https://atlas.over9000.cc",
    screenshot: "/shots/atlas.svg",
    shippedAt: "2026-09-19",
    status: "wip",
    example: true,
    blurb: "Seed frame — a map of the quest. Not deployed.",
  },
];
